// Sentry MUST be the first import so global error handlers are hooked
// before any application code runs. Playbook is firm on this.
import "@/instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// React 19 root-level error hooks — Sentry's reactErrorHandler wires
// the SDK to onUncaughtError / onCaughtError / onRecoverableError so
// errors that escape ErrorBoundaries still reach Sentry.
const root = ReactDOM.createRoot(document.getElementById("root"), {
  onUncaughtError:    Sentry.reactErrorHandler(),
  onCaughtError:      Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
